import React from 'react'
import styles from './ScoutOfferPattern.module.css'
import { ScoutOfferPatternProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { CtaButton } from './CtaButton'

const IMAGE_DIR = '/pages/abtest/dev3392'

// DEV-3392 Bパターン: コンテンツを圧縮して「求められる感」でハードルを下げる。
// KUZEN(LINE連携)バナーはページから外し、LineLinkModalに移す（ThanksPage側で制御）。
export const ScoutOfferB = ({
    telImageSrc,
    upgradeUrl,
    expiredDate,
}: ScoutOfferPatternProps) => {
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.body}>
            <img
                src={`${IMAGE_DIR}/b_head.png`}
                alt='ご登録ありがとうございます！'
                className={styles.strip}
            />
            <div className={styles.telRowB}>
                <div className={styles.telCardB}>
                    <img src={telImageSrc} alt='TEL画像' className={styles.telImage} />
                </div>
            </div>
            <div data-view-label={dataViewLabel('Thanks_CT_スカウト')}>
                <div data-view-label={dataViewLabel('Thanks_CT_スカウト_コンテンツ1')}>
                    <img
                        src={`${IMAGE_DIR}/b_offer.png`}
                        alt='飲食転職を快適にするスカウト転職へのスペシャルオファー'
                        className={styles.strip}
                    />
                    <div className={styles.dateRow}>
                        <img src={`${IMAGE_DIR}/b_date.png`} alt='' className={styles.strip} />
                        {expiredDate && (
                            <p className={styles.dateText}>
                                <span>
                                    {expiredDate.month}
                                    <span className={styles.dateUnit}>月</span>
                                    {expiredDate.day}
                                    <span className={styles.dateUnit}>日</span>
                                </span>
                                <span>{expiredDate.time}</span>
                            </p>
                        )}
                    </div>
                </div>
                <CtaButton
                    bgSrc={`${IMAGE_DIR}/b_cta1_bg.png`}
                    bgWidth={750}
                    bgHeight={132}
                    button={{ x: 87, y: 9, w: 576, h: 102 }}
                    shape='square'
                    text='今すぐスカウトを受け取る'
                    href={upgradeUrl}
                    dataClickLabel={dataClickLabel('Thanks_CT_スカウト_CTAボタン1')}
                />
                <img
                    src={`${IMAGE_DIR}/b_benefit.png`}
                    alt='アップグレード特典：スカウト上位表示30日間、登録するだけで飲食企業からスカウトが届く'
                    className={styles.strip}
                />
                <div data-view-label={dataViewLabel('Thanks_CT_スカウト_コンテンツ2')}>
                    <img
                        src={`${IMAGE_DIR}/b_upgrade.png`}
                        alt='アップグレードするには？所要時間2分、次のページで基本情報や職歴を登録するだけ！'
                        className={styles.strip}
                    />
                </div>
                <CtaButton
                    bgSrc={`${IMAGE_DIR}/b_cta2_bg.png`}
                    bgWidth={750}
                    bgHeight={136}
                    button={{ x: 87, y: 22, w: 576, h: 102 }}
                    shape='square'
                    text='今すぐスカウトを受け取る'
                    href={upgradeUrl}
                    dataClickLabel={dataClickLabel('Thanks_CT_スカウト_CTAボタン2')}
                />
                <img src={`${IMAGE_DIR}/b_tail.png`} alt='' className={styles.strip} />
            </div>
        </div>
    )
}

export default ScoutOfferB
